import login3 from "./login3";
import collect3 from "./collect3";
import reconnect3 from "./reconnect3";
import setUserPersistentProfile3 from "./setUserPersistentProfile3";
import refreshToken from "./refreshToken";
import cancelLogin from "./cancelLogin";
import sign3 from "./sign3";

const user3 = {
  login3,
  collect3,
  reconnect3,
  setUserPersistentProfile3,
  refreshToken,
  cancelLogin,
  sign3,
};

export default user3;
